var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Contact/Phone_Big") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Drf_Contact-Mobile",
    transform: "translate(-36.000000, -253.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Contact/Phone_Big",
    transform: "translate(32.000000, 249.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6167246,24.1270388 L26.4829019,21.5995212 C25.7636639,21.0321193 24.7361811,20.9805373 24.0169431,21.5479392 L21.3454877,23.5080549 C21.0372428,23.7659649 20.5748755,23.7143829 20.2666307,23.4048909 L16.2594475,19.7941515 L12.6632576,15.7707562 C12.3550127,15.4612643 12.3550127,15.0486083 12.5605093,14.6875344 L14.5127267,12.0052708 C15.0778423,11.2831229 15.0264681,10.2514831 14.4613525,9.52933524 L11.9440196,6.38283376 C11.1734074,5.45435791 9.78630556,5.35119393 8.91294513,6.22808778 L6.24148971,8.91035134 C5.83049657,9.32300727 5.625,9.89040918 5.625,10.4578111 C5.88187071,15.7191742 8.24508128,20.7226274 11.738523,24.2302028 C15.2319647,27.7377782 20.2152565,30.1105498 25.4554191,30.3684598 C26.0205347,30.4200418 26.5856502,30.1621318 26.9966434,29.7494759 L29.6680988,27.0672123 C30.6442075,26.2934825 30.5928334,24.8491867 29.6167246,24.1270388 L29.6167246,24.1270388 Z",
    id: "\\uD83C\\uDFA8-Color",
    stroke: "#343434",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBig);
export default __webpack_public_path__ + "static/media/Phone_Big.263cf93f815f8d6930b1449c0ff6e3fb.svg";
export { ForwardRef as ReactComponent };